import {
	API_ADMIN_GET_ALL_PARTNERS,
	API_ADMIN_GET_PARTNER,
	API_ADMIN_PATCH_PARTNER,
	API_ADMIN_POST_PARTNER,
	API_ADMIN_DELETE_PARTNER,
	ADMIN_INIT_NEW_PARTNER,
	ADMIN_RESET_FOCUS_PARTNER,
} from "actions/partnerCompany";

export function adminGetAllPartners() {
	return {
		type: API_ADMIN_GET_ALL_PARTNERS,
		payload: {
			request: {
				url: `/partners`,
			},
		},
	};
}

export function adminGetPartnerById(partnerCompanyId) {
	return {
		type: API_ADMIN_GET_PARTNER,
		payload: {
			request: {
				url: `/admin/partners/${partnerCompanyId}`,
			},
		},
	};
}

export function adminPatchPartner(partner) {
	return {
		type: API_ADMIN_PATCH_PARTNER,
		payload: {
			request: {
				url: `/admin/partners/${partner.id}`,
				method: "PATCH",
				data: partner,
			},
		},
	};
}

export function adminPostPartner(partner) {
	return {
		type: API_ADMIN_POST_PARTNER,
		payload: {
			request: {
				url: `/admin/partners`,
				method: "POST",
				data: partner,
			},
		},
	};
}

export function adminDeletePartner(partnerCompanyId) {
	return {
		type: API_ADMIN_DELETE_PARTNER,
		payload: {
			request: {
				url: `/admin/partners/${partnerCompanyId}`,
				method: "delete",
			},
		},
	};
}

export function initNewPartner() {
	return {
		type: ADMIN_INIT_NEW_PARTNER,
	};
}

export function resetFocusPartner() {
	return {
		type: ADMIN_RESET_FOCUS_PARTNER,
	};
}
